module.exports = "/_next/static/images/344a8b84c109d28afcab25dfb949fad9-device-frame-dark@1x.png.webp";